<template>
    <div class="title" :class="{ 'animate-from-top': animated }">
      <h2 >{{ title }}</h2>
      <div class="wrapper">
        <div class="text-wrapper">{{ description }}</div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'Title',
    props: [
      'title',
      'description'
    ],
    data() {
    return {
      animated: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollY = window.scrollY;
      const threshold = this.$el.offsetTop - window.innerHeight / 1;
      if (scrollY > threshold) {
        this.animated = true;
      }  else {
        this.animated = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/styles/constants.scss';

  .title {
    text-align: center;
    color: map-get($colors, primary);
    h2 {
      font-size: 4rem;
      text-transform: uppercase;
    }
  }

  .animate-from-top {
  animation: slide-down 0.5s ease-out forwards;
}

@keyframes slide-down {
  0% {
    transform: translateY(-50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

  .text-wrapper {
    text-transform: uppercase;
    &:after {
      content: "";
      width: 150px;
      display: block;
      margin: 20px auto;
      border-bottom: 1px solid map-get($colors, primary);
    }
  }
</style>